import React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const ArticleCard = ({ article, noPadding }) => {
  return (
    <article className={`block h-full relative ${!noPadding && "pb-10"}`}>
      <Link
        className="relative block no-underline overflow-hidden rounded-[10px] bg-[#F2F2F2] text-black transition-shadow duration-200
        hover:shadow-card h-auto"
        to={`/blogs/campfire-chats/${article.slug}`}
      >
        {/* Image */}
        <div className="block h-1/2 overflow-hidden">
          <div className="pb-[50%] transition-all duration-[400ms] relative block bg-black/10 overflow-hidden h-full">
            {article.thumbnailImage?.gatsbyImageData && (
              <div className="absolute top-0 left-0 max-w-full align-bottom w-full h-full block">
                <GatsbyImage
                  image={article.thumbnailImage.gatsbyImageData}
                  alt={article.thumbnailImage.title ?? article.title}
                  loading="lazy"
                  objectFit="cover"
                  className="w-full h-full object-cover"
                />
              </div>
            )}
          </div>
        </div>
        {/* Content */}
        <div className="py-4 px-4 sm:px-[30px] xl:p-[30px] flex flex-col justify-between box-border">
          <div className="block">
            <h4 className="text-base md:text-lg font-bold md:h-14 tracking-wide overflow-hidden">
              {article.title}
            </h4>
            {article.contributor && (
              <h6 className="font-bold text-sm mt-3">
                by {article.contributor.title}
              </h6>
            )}
            <span className="text-[10px] md:text-xs text-black/60 tracking-wide mt-3">
              {article.createdAt}
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default ArticleCard;
